import { flatten } from 'flat';
import { cloneDeep, get, merge } from 'lodash';
import { defaultColorPalettes } from './default-color-palettes';
export var getColorPalettes = colors => {
  var colorPalettes = merge(cloneDeep(defaultColorPalettes), colors);
  Object.values(colorPalettes).forEach(colorType => {
    Object.entries(colorType).forEach(_ref => {
      var [key, value] = _ref;
      return colorType[key] = get(colorPalettes, value, value);
    });
  });
  return colorPalettes;
};
export var getComponentColorOverrides = (colorPalettes, _ref2) => {
  var {
    components: componentColors
  } = _ref2;
  if (!componentColors) return componentColors;
  var flatColorPalettes = flatten(colorPalettes);

  var replaceColorsWithPalettes = (_, value) => {
    if (typeof value !== 'object') {
      var keyWithPaletteColor = Object.keys(flatColorPalettes).find(color => value === color);
      return keyWithPaletteColor ? flatColorPalettes[keyWithPaletteColor] : value;
    } else {
      return value;
    }
  };

  var newComponentColors = JSON.parse(JSON.stringify(componentColors), replaceColorsWithPalettes);
  return newComponentColors;
};
export var getThemeColorKeys = () => flatten(defaultColorPalettes);
export var getColorByBgColor = _ref3 => {
  var {
    bgColor,
    darkColor = 'black',
    lightColor = 'white'
  } = _ref3;
  var hexCode = bgColor.charAt(0) === '#' ? bgColor.substr(1, 6) : bgColor;
  var hexR = parseInt(hexCode.substr(0, 2), 16);
  var hexG = parseInt(hexCode.substr(2, 2), 16);
  var hexB = parseInt(hexCode.substr(4, 2), 16); // Gets the average value of the colors

  var contrastRatio = (hexR + hexG + hexB) / (255 * 3);
  return contrastRatio >= 0.7 ? darkColor : lightColor;
};
//# sourceMappingURL=utils.js.map